import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { showError } from 'utils';
import { tableStyles } from '../../../css/tableStyles';
import styles from './index.module.scss';
import ActionButton from 'components/ActionButton';
import CustomLink from 'components/TableLink';
import { fetchAllStripeProductsForAdmin } from 'services';

const StripeProductsList = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [stripeProducts, setStripeProducts] = useState([]);

  const fetchAllStripeProductsFn = async () => {
    setLoading(true);
    try {
      const response = await fetchAllStripeProductsForAdmin();
      setStripeProducts(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllStripeProductsFn();
  }, []);

  const columns = useMemo(() => [
    {
      name: 'Id',
      selector: 'objectId',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/stripe-products/${row.slug}`}
        />
      ),
    },
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
    },
    {
      name: 'Stripe Product Id',
      selector: 'stripeProductId',
      sortable: true,
    },
    {
      name: 'Slug',
      selector: 'slug',
      sortable: true,
    },
    {
      name: 'Active',
      selector: 'active',
      sortable: true,
      format: (row) => row.active?.toString() || 'false',
    },
  ], []);

  const getHeader = () => {
    return(
      <div className={styles['header']}>
        <div className={styles['heading']}>Stripe Products</div>
        <div className={styles['buttons-container']}>
          <ActionButton
            text={<>Stripe Product <span>+</span></>}
            active={true}
            isLoading={false}
            onClick={()=>{props.history.push('/stripe-products/create')}}
            customClass={styles['add-new-pick-pack-button']}
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className={styles['main-container']}>
        {getHeader()}
        <DataTable
          keyField="objectId"
          columns={columns}
          noHeader={true}
          data={stripeProducts}
          highlightOnHover={true}
          customStyles={tableStyles}
          pagination={false}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default StripeProductsList;
